import {
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  VStack,
} from '@chakra-ui/react';

import {FormProvider} from 'react-hook-form';
import {useParams} from 'react-router';
import {useNavigate} from 'react-router-dom';

import {ShowSpinnerWhile} from '../../components/ShowSpinnerWhile';
import FollowUpQuestion from './follow-up-question';
import {useFollowup} from './useFollowup';

export function FollowupQuestions() {
  const {idSet} = useParams();
  const navigate = useNavigate();
  const {isLoading, questions, form, onSubmit, isSaving} = useFollowup(idSet);

  return (
    <Drawer
      isOpen={true}
      placement='right'
      size='sm'
      onClose={() => navigate(-1)}>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>Seguimiento</DrawerHeader>
        <DrawerBody>
          <FormProvider {...form}>
            <form onSubmit={onSubmit} id='follow-up-form'>
              <VStack>
                <ShowSpinnerWhile condition={!isLoading} spinnerSize='lg'>
                  {questions.map(question => (
                    <FollowUpQuestion key={question.id} question={question} />
                  ))}
                </ShowSpinnerWhile>
              </VStack>
            </form>
          </FormProvider>
        </DrawerBody>

        <DrawerFooter>
          <Button
            colorScheme='green'
            type='submit'
            form='follow-up-form'
            isLoading={isSaving}>
            Guardar
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
